import React, { useEffect, useState, useRef } from "react";
import { FxmsPopup, FxPopup, FxmsContentDashboardDialog } from "../windows/FxWindows";
import { FxResource } from "./FxResource";

export const FxButton = props => {
  const btnRef = useRef(null);
  const resourceRef = useRef(null);
  const { attr, clickButton, inputType } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(props.selectedData);
  const [selectedDataId, setSelectedDataId] = useState(props.selectedDataId);
  const disabled = attr.readOnlyYn === 'Y';
  const sx = makeSx(props);
  const opObj = attr.linkOpObj;

  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    console.log("*** FxButton ***", opObj);

    setModalOpen(true);
  };

  useEffect(() => {
    console.log("*** FxButton ***", opObj);
    if (props.onButtonRef) {
      props.onButtonRef(attr, btnRef, resourceRef);
      resourceRef.current = function (id, data) {
        console.log("*** FxButton ***", attr.attrName, id, data);
        setSelectedData(data);
        setSelectedDataId(id);
      }
    }
  }, []);

  if (opObj && (opObj.isUi() || opObj.isDashboard() || opObj.isComponent())) {

    return (
      <>
        <input className={"FxButton" + (inputType === undefined ? "" : inputType)} type="button" id={attr.attrName} style={sx} onClick={openModal} disabled={disabled} value={attr.attrUiTxt} ref={btnRef} />
        <FxmsPopup open={modalOpen} closeModal={closeModal} dialogTitle={opObj.opTitle} opObj={opObj}>
          <FxResource menu={opObj} attr={attr} selectedData={selectedData} selectedDataId={selectedDataId} resourceRef={resourceRef} onCloseBtnClick={closeModal} />
        </FxmsPopup>
      </>
    );

  } else {

    return (
      <>
        <input className={"FxButton" + (inputType === undefined ? "" : inputType)} type="button" id={attr.attrName} style={sx} onClick={clickButton} disabled={disabled} value={attr.attrUiTxt} ref={btnRef} />
      </>
    );
  }

}



export const FxButtonContent = props => {
  const { attr } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const sx = makeSx(props);
  const opObj = attr.linkOpObj;

  const closeModal = () => {
    console.log("*** FxButtonContent ***  closeModal");
    setModalOpen(false);
  };

  const openModal = () => {
    console.log("*** FxButtonContent ***  openModal");
    if ( modalOpen ) {
      setIndex(index + 1);
    } else {
      setModalOpen(true);
    }
  };

  useEffect(() => {
  }, []);

  if (opObj && (opObj.isUi() || opObj.isDashboard() || opObj.isComponent())) {

    return (
      <>
        <input className="FxButtonContent" type="button" id={attr.attrName} style={sx} onClick={openModal} value={attr.attrUiTxt} />
        <FxmsContentDashboardDialog open={modalOpen} closeModal={closeModal} dialogTitle={opObj.opTitle} opObj={opObj} index={index}>
          <FxResource menu={opObj} />
        </FxmsContentDashboardDialog>
      </>
    );

  }

  return (
    <></>
  );

}




function makeSx(props) {

  const sx = {};

  // if (attr.uiWidth > 0) {
  //   sx.minWidth = attr.uiWidth;
  //   sx.width = attr.uiWidth;
  // } else {
  //   sx.width = '100%';
  // }

  if (props.isPopupCrud) {
    // sx.width = '100%';
  }

  return sx;
}



export const FxButton2 = props => {
  const { attrClass, para } = props;
  const btnRef = useRef(null);
  const resourceRef = useRef(null);
  const sx = attrClass.getStyle();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(props.selectedData);
  const [selectedDataId, setSelectedDataId] = useState(props.selectedDataId);
  const opObj = attrClass.getLinkOpObj();
  const attr = attrClass.getAttr();

  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    console.log("*** FxButton ***", opObj);

    setModalOpen(true);
  };

  useEffect(() => {
    console.log("*** FxButton ***", opObj);
    if (props.onButtonRef) {
      props.onButtonRef(attr, btnRef, resourceRef);
      resourceRef.current = function (id, data) {
        console.log("*** FxButton ***", attr.attrName, id, data);
        setSelectedData(data);
        setSelectedDataId(id);
      }
    }
  }, []);

  if (opObj && (opObj.isUi() || opObj.isDashboard() || opObj.isComponent())) {

    return (
      <>
        <input className="FxButton" type="button" id={attrClass.getId()} onClick={openModal} disabled={attrClass.isDisable()} value={attr.attrUiTxt} ref={btnRef} />
        <FxmsPopup open={modalOpen} closeModal={closeModal} dialogTitle={opObj.opTitle} opObj={opObj}>
          <FxResource menu={opObj} selectedData={selectedData} selectedDataId={selectedDataId} resourceRef={resourceRef} onCloseBtnClick={closeModal} />
        </FxmsPopup>
      </>
    );

  } else {

    return (
      <>
        <input className="FxButton" type="button" id={attrClass.getId()} onClick={para.onClick} disabled={attrClass.isDisable()} value={attr.attrUiTxt} ref={btnRef} />
      </>
    );
  }

}




/**
 * 기본 Select 박스
 * 
 * @param {function(name)} onClick  선택되었을 때 호출하는 함수 function(name)
 * @param {string} name ID 및 이름
 * @param {string} className css명
 * @param {boolean} disabled 비활성화여부
 * @param {number} width 넓이
 * @param {string} text 버튼문구
 * @returns 
 */
export const FxButtonBase = props => {
  const { onClick, name, className, disabled, width, text } = props;
  const sx = {};

  // 길이가 정의되어 있으면 지정
  if (width > 0) {
    sx.minWidth = width;
    sx.width = width;
  }

    return (
      <>
        <input className={className ? className : "FxButton"} type="button" id={name} style={sx} onClick={function() { onClick(name); }} disabled={disabled} value={text}  />
      </>
    );


}